import React, { useState } from 'react';

import { Navigate } from 'react-router-dom';
import { Logo } from '../../components/Logo';
import { Input } from '../../components/Input';
import { Hint } from '../../components/Hint';
import { Button } from '../../components/Button';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLogin, setError } from '../../redux/authSlice';
import { validateForm } from './helpers';


export const Login = ({}) => {

    const [login, setLogin] = useState('');
    const [password, setPass] = useState('');
    const dispatch = useDispatch();
    const loginError = useSelector((state) => state.auth.error);
    const isUserAuth = useSelector((state) => state.auth.isAuth);

    if (isUserAuth) return <Navigate to="/" />;

    const buttonClickHandler = () => {
        const checkValidForm = validateForm(login, password);
        if (!checkValidForm.isValid) {
            return dispatch(setError(checkValidForm.message))
        }
        dispatch(fetchLogin({login: +login, password}));
    }
    
    return (<main className='login__wrapper'>
        <div className='login__window'>
            <Logo height={78}/>
            <div className="login__form">
                <div className='login__input'>
                    <Input label='Логин' id='login' value={login} changeHandler={(evt) => setLogin(evt.target.value)}/>
                </div>
                <div className='login__input'>
                    <Input type='password' label='Пароль' id='pass' value={password} changeHandler={(evt) => setPass(evt.target.value)}/>
                </div>
                <div className='login__button'>
                    <Button onClick={buttonClickHandler} text='Войти'/>
                </div>
                <Hint hidden={loginError === null ? true : false} type='error' text={loginError} />
            </div>
        </div>
    </main>);
}